import moment from 'moment';
import config from '../../config.js';

const api = config['apiServerUrl']+config['generalApiUrl']+"event/";

/*
{
        "id": 5,
        "name": "e1",
        "dates": "",
        "start_time": "11:11:00",
        "end_time": "22:22:00",
        "tags": [],
        "active_exceptional": true,
        "is_valid": false
    }
*/

// Handle HTTP errors since fetch won't.
function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


const events = [];
console.log(events);
/*
const datediff = new moment(new Date()).diff(
  new moment('2017-06-01T18:23:07.322Z'),
  'days'
);
events.forEach((event, index) => {
  events[index].id = `${index + 1}`;
  events[index].title = 's';
  events[index].start = new moment(event.start).add(datediff, 'days').toDate();
  events[index].end = new moment(event.end).add(datediff, 'days').toDate();
}); */
export default events;



// WEBPACK FOOTER //
// ./src/containers/Event/fetchEvents.js